import merge from 'lodash/merge';
import { fetcher } from '../utils/fetcher';
import { generateEmbed, warmConnections } from "../utils/vimeo";

class VideoPlayer {
  constructor( container, options ){
    this.container = container;
    this.settings = merge( {}, VideoPlayer.DEFAULTS, options );
    this.player = null;
    this.handlePlayClick = this.handlePlayClick.bind(this);

    this.init();
  }

  async init(){
    const { classNames, btnText } = this.settings;
    this.data = await fetcher.get(`https://vimeo.com/api/oembed.json?url=https://vimeo.com/${this.settings.videoId}`);

    this.container.innerHTML = `
      <img class="${classNames.thumb}" src="${this.data.thumbnail_url}" alt="${this.data.title}" loading="lazy">
      <button class="${classNames.btn}" type="button" aria-label="${btnText}"></button>
    `;

    this.container.querySelector('button')
      .addEventListener('click', this.handlePlayClick );

    this.container.addEventListener('pointerover', warmConnections, {
      once: true
    });
  }

  handlePlayClick(){
    const { videoId, playerParameters } = this.settings;
    this.player = generateEmbed(videoId, playerParameters);
    this.container.replaceChildren(this.player);
  }
}

VideoPlayer.DEFAULTS = {
  videoId: null,
  btnText: 'Watch video',
  classNames: {
    thumb: 'VideoPlayer-thumb',
    btn: 'VideoPlayer-btn'
  },
  // See https://vimeo.zendesk.com/hc/en-us/articles/360001494447-Using-Player-Parameters
  playerParameters: {
    color: 'f39200',
    dnt: true,
    byline: false
  }
};

document.querySelectorAll( '.js-VideoPlayer' )
  .forEach( element => new VideoPlayer( element, element.dataset ) );

export default VideoPlayer;
